import React , { useEffect, useState }from 'react'
import IfSamePathThenScrollToTop from '../../Utility/IfSamePathThenScrollToTop'
import './Header.scss';
import { NavLink } from 'react-router-dom';
import causalLogo from '../../../assets/images/mains/CausalFunnelFullLogo.svg'

const Header = () => {
  const [showMobMenu, setShowMobMenu] = useState(false);
  const toggleMobileMenu = () => {
    setShowMobMenu(!showMobMenu);
    showMobMenu ? document.body.style.overflow = "auto" : document.body.style.overflow = "hidden";
  };
  window.onscroll = function() {scrollFunction()};

  useEffect(() => {
    document.body.style.overflow = "auto"
  }, [])

  function scrollFunction() {
    if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
      //document.getElementById("mynavbar").style.
      document.getElementById("mynavbar").style.boxShadow= "0 6px 10px -4px rgb(0 0 0 / 15%)";
    } else {
      document.getElementById("mynavbar").style.boxShadow= "none";
    }
  }
  

  return (
    <div className="navbar-area" id='mynavbar'>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">

          {/* Start of mobile-screen navbar */}
            <div
              className={`d-block d-lg-none mobile-menu only-mobile ${
                showMobMenu ? "overlay" : ""
              }`}
            >
              <div className="mobile-navbar">
                <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/platform">
                  <div className="mobile-nav-item" onClick={toggleMobileMenu}> Platform </div>
                </NavLink>
                <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/company">
                  <div className="mobile-nav-item" onClick={toggleMobileMenu}> Company</div>
                </NavLink>
                <a href='https://www.blog.causalfunnel.com/'>
                  <div className="mobile-nav-item" onClick={toggleMobileMenu}> Blog</div>
                </a>
                {/* <NavLink to="/blog">
                  <div className="mobile-nav-item"> Blog</div>
                </NavLink> */}
                <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/free-trial">
                  <div className="mobile-nav-item" onClick={toggleMobileMenu}> Free Trial</div>
                </NavLink>
              </div>
            </div>

            
          {/* End of mobile-screen navbar */}

            <nav className="navbar navbar-expand-lg">
              <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/" className=" navbar-brand ">
                <img src={causalLogo} className="causalLogo img-fluid" alt="CausalFunnel Logo"/>
              </NavLink>

          {/* Start of mobile-screen hamburger */}
              <div className="hamburger-container d-block d-lg-none">
                <button
                  className={`hamburger hamburger--slider ${
                    showMobMenu ? "is-active" : ""
                  }`}
                  type="button"
                  onClick={toggleMobileMenu}
                >
                  <span className="hamburger-box">
                    <span className="hamburger-inner"></span>
                  </span>
                </button>
              </div>
          {/* end of mobile-screen hamburger */}

              <div
                className="collapse navbar-collapse sub-menu-bar"
                id="navbarSupportedContent"
              >
                <div className="ms-auto">
                  <ul id="nav" className="navbar-nav ms-auto">
                    <li className="nav-item">
                      <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/platform">PLATFORM</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/company">COMPANY</NavLink>
                    </li>
                    <li className="nav-item">
                      {/* <NavLink to="/blog">BLOG</NavLink> */}
                      <a href='https://www.blog.causalfunnel.com/'>BLOG</a>
                    </li>
                    <li className="nav-item trialBtn">
                      <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/free-trial" className="text-white">FREE TRIAL</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
            <div className={showMobMenu?'blur-screen':'d-block'} onClick={toggleMobileMenu}></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header